import { render, staticRenderFns } from "./JcqklrRoute.vue?vue&type=template&id=af3dfec6"
import script from "./JcqklrRoute.vue?vue&type=script&lang=js"
export * from "./JcqklrRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports